import Badge from './badge';
import './styles/index.scss';
export default Badge;
